import { render, staticRenderFns } from "./playVideo.vue?vue&type=template&id=687a124b&scoped=true&"
import script from "./playVideo.vue?vue&type=script&lang=js&"
export * from "./playVideo.vue?vue&type=script&lang=js&"
import style0 from "./playVideo.vue?vue&type=style&index=0&id=687a124b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a124b",
  null
  
)

export default component.exports